const LiveIndicator = () => {
    return (
        <div className={"flex items-center text-sm font-light text-red-400"}>
            <p className={"flex items-center text-sm font-light text-red-400"}>
                <span
                    className="relative flex h-3 w-3 mx-2">
                    <span
                        className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"/>
                    <span
                        className="relative inline-flex rounded-full h-3 w-3 bg-red-500"/>
                </span>
                <span>Trwa</span>
            </p>
        </div>
    );
};

export default LiveIndicator;